<template>
    <div>
        <van-tabs v-model="active" swipeable animated sticky color="#066BEE" line-height="2px"
                  @change="getListData()">
            <van-tab v-for="item in list" :key="item.type" :title="item.title">
                <van-list v-if="item.list.length > 0" v-model="item.loading" :finished="item.finished"
                          finished-text="没有更多了" @load="getListData">
                    <div v-for="(subItem,index) in item.list" :key="index" class="card" @click="gotoDetail(subItem)">
                        <div style="margin: 5px 10px 10px 10px; padding-bottom: 10px; font-weight: bold; color: #4E4E4E; font-size: 18px; border-bottom: 1px #EDEDED solid;">
                            {{subItem.prodName}}
                        </div>
                        <div style="display: flex; justify-content: space-between;">
                            <div>
                                <div style="margin: 0 0 10px 10px; color: #999999; font-size: 14px;">{{'家庭关系：' +
                                    subItem.userRelation}}
                                </div>
                                <div style="margin: 0 0 10px 10px; color: #999999; font-size: 14px;">{{'保险金额(元)：' +
                                    subItem.amount/100}}
                                </div>
                                <div v-if="subItem.effectiveDate" style="margin: 0 0 10px 10px; color: #999999; font-size: 14px;">保障时间：{{subItem.effectiveDate|dateFormat('YYYY-MM-DD')}}至{{subItem.deadline|dateFormat('YYYY-MM-DD')}}
                                </div>
                            </div>
                            <div style="display: flex; align-items: center;">
                                <van-icon name="arrow" color="#C8C8C8" style="margin-right: 5px;"></van-icon>
                            </div>
                        </div>
                    </div>
                </van-list>
                <div v-else
                     style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                    <van-image :src="require('@/assets/无数据.png')" width="120px" height="94px" style="margin-top: 35%;"/>
                    <span style="margin-top: 20px; color: #999999; font-size: 14px;">{{`暂无${item.title}的订单`}}</span>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>


    import Vue from 'vue';
    import {Tab, Tabs, List, Cell, Icon, Image} from 'vant';
    import Cookies from 'js-cookie'

    Vue.use(Tab).use(Tabs).use(List).use(Cell).use(Icon).use(Image);

    export default {
        name: "FamliyOrder",
        data() {
            return {
                type: Cookies.get('type'),
                active: 0,
                pageSize: 10,
                list: [
                    {title: '保障中', type: '3', list: [], page: 0, loading: false, finished: false},
                    {title: '待支付', type: '1', list: [], page: 0, loading: false, finished: false},
                    {title: '待生效', type: '2', list: [], page: 0, loading: false, finished: false},
                    {title: '已失效', type: '4', list: [], page: 0, loading: false, finished: false},
                ],
            }
        },
        created() {
            this.getListData()
        },
        methods: {
            getListData() {
                const item = this.list[this.active]
                if (item.finished) {
                    return;
                }
                item.page++
                item.loading = true
                this.$axios.get("/order/family", {
                    params: {
                        states: item.type,
                        page: item.page,
                        pageSize: this.pageSize,
                        type: this.type
                    }
                }).then(res => {
                    item.loading = false
                    const datas = res.data.rows;
                    item.list = item.list.concat(datas);
                    if (datas.length < this.pageSize) {
                        item.finished = true;
                    }
                }).catch(err => {
                    console.log(err);
                    item.loading = false
                })
            },
            add() {
                this.$router.push('/addFamily')
            },
            gotoDetail(item){
                // this.$axios.get("/jump/insureUrl", {params: {insureNum: item.insureNum}}).then(res => {
                //     window.location.href = res.data
                // });
                this.$router.push({path:'/orderDetail',query:{id:item.userBuyId}})
            }
        }
    }
</script>

<style scoped>
    .card {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px 0;
        margin: 10px;
        background-color: white;
        box-shadow: 0px 2px 4px 0px rgba(231, 231, 231, 0.5);
        border-radius: 4px;
    }

</style>
